import { range } from "../../misc/object";
import { useState, useEffect } from "react";
import { getMonthName } from "../../misc/date";
import { Button } from "./buttons";

const selections = {
    months: [ 
        "January", "February", "March", 
        "April", "May", "June", "July", 
        "August", "September", "October",
        "November", "December"
    ],
    years: range(1990, new Date().getFullYear()+1)
};

export function MonthYearSelector({ month = 1, year = new Date().getFullYear(), onChange }) {
    
    const [ selected, setSelected ] = useState({ month, year });
    const [ selectionVisible, setVisibility ] = useState(false);

    const monthIndex = month - 1;
    const yearIndex = selections.years.indexOf(year);

    let currentMonth = month;
    let currentYear = year;

    const change = () => {
        const newSelected = { month: currentMonth, year: currentYear };
        onChange(newSelected);
        setSelected(newSelected);
        close();
    };

    const toggle = () => setVisibility(!selectionVisible);
    const close = () => setVisibility(false);
    

    return <div className="myselector-wrapper">
        <div className="myselector" onClick={toggle}>{getMonthName(selected.month)} {selected.year}</div>
        <div className={"selection right" + (selectionVisible ? " visible" : "")}>
            <header>SELECT MONTH<button onClick={close} className="close-btn"></button></header>
            <main>
                <HorizontalSelection options={selections.months} index={monthIndex}
                    onChange={(index) => currentMonth = index + 1} />
                <HorizontalSelection options={selections.years} index={yearIndex}
                    onChange={(_, value) => currentYear = value} />
            </main>
            <footer>
                <Button color="green" icon="edit" onClick={change}>CHANGE</Button>
            </footer>
        </div>
    </div>;
}

export function YearSelector({ year = new Date().getFullYear(), onChange }) {
    
    const [ selected, setSelected ] = useState({ year });
    const [ selectionVisible, setVisibility ] = useState(false);

    const yearIndex = selections.years.indexOf(year);
    let currentYear = year;

    const change = () => {
        const newSelected = { year: currentYear };
        onChange(newSelected);
        setSelected(newSelected);
        close();
    };

    const toggle = () => setVisibility(!selectionVisible);
    const close = () => setVisibility(false);
    

    return <div className="myselector-wrapper">
        <div className="myselector year" onClick={toggle}>{selected.year}</div>
        <div className={"selection" + (selectionVisible ? " visible" : "")}>
            <header>SELECT YEAR<button onClick={close} className="close-btn"></button></header>
            <main>
                <HorizontalSelection options={selections.years} index={yearIndex}
                    onChange={(_, value) => currentYear = value} />
            </main>
            <footer>
                <Button color="green" icon="edit" onClick={change}>CHANGE</Button>
            </footer>
        </div>
    </div>;
}

export function HorizontalSelection({ options, index, onChange }) {
    const [ currentIndex, setIndex ] = useState(index);

    const isLeftEnd = currentIndex === 0;
    const isRightEnd = currentIndex + 1 >= options.length;
    const currentValue = options[currentIndex];

    const navigate = (direction) => {
        const temp = currentIndex + direction;
        if(temp >= 0 && temp < options.length) {
            setIndex(temp);
        }
    };

    const navLeft = () => navigate(-1);
    const navRight = () => navigate(1);

    useEffect(() => onChange(currentIndex, currentValue));
    
    return <div className="hselection">
        <div className="selection-left"><button onClick={navLeft} className={isLeftEnd ? " disabled" : ""}></button></div>
        <label>{currentValue}</label>
        <div className="selection-right"><button onClick={navRight} className={isRightEnd ? " disabled" : ""}></button></div>
    </div>
}